import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  code: {
    id: 'pd.discount.code',
    defaultMessage: 'notino',
  },
  codeInCart: {
    id: 'pd.discount.code.in.cart',
    defaultMessage: 'Kód zadejte v košíku',
  },
  conditionText: {
    id: 'pd.discount.condition.text',
    defaultMessage: 'Nevztahuje se na zboží v akci a ve výprodeji',
  },
  descriptionText: {
    id: 'pd.discount.description.text',
    defaultMessage: '{highlighted} s kódem {code}',
  },
  discountAmount: {
    id: 'product.item.discount.highlighted',
    defaultMessage: '-{amount} %',
  },
});
